<template>
    <Head title="Sumamry Attendance"></Head>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <div class="p-fluid formgrid grid">
                            <div class="field col-12">
                                <Dropdown
                                    v-if="userDetail.roles == 'admin'"
                                    v-model="placement"
                                    :options="placements"
                                    optionLabel="name"
                                    optionValue="id"
                                    placeholder="Select Placement"
                                    showClear
                                    editable
                                    @change="filterByPlacement"
                                />
                            </div>
                        </div>
                    </template>
                </Toolbar>
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Ringkasan Jadwal dan Kehadiran</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="searchFilter"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                    ></Column>
                    <Column
                        field="name"
                        header="Name"
                        :sortable="true"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            {{ slotProps.data.name }}
                        </template>
                    </Column>
                    <Column
                        v-for="i in date"
                        :key="i"
                        :field="`${i}`"
                        :header="i"
                        :sortable="false"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">{{ i }}</span>
                            <i :class="slotProps.data[i] ? status[slotProps.data[i]['as']] : status['unshift']"></i>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import DatatableService from "../../../Services/DatatableService";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Button,
        InputText,
        Toolbar,
        Toast,
        DataTable,
        Column,
        Dropdown,
        Dialog,
    },
    data() {
        return {
            searchFilter: "",
            filters: {},
            lazyParams: {},
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            model: {},
            models: null,
            selectedModels: null,
            submitted: false,
            selectAll: false,
            isExporting: false,
            date: 0,
            status: {
                'holiday': 'pi pi-star text-yellow-600',
                'present': 'pi pi-check text-green-600',
                'absent': 'pi pi-times text-red-600',
                'unshift': 'pi pi-ban text-red-800',
            },
            userDetail: JSON.parse(sessionStorage.getItem('auth:me')) ?? [],
            startDate: null,
            endDate: null,
            placements: [],
            placement: '',
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
        let date = new Date();
        this.currentDate(date.getFullYear(), date.getMonth())
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };

        this.loadSeachableData();
        this.loadLazyData();
    },
    methods: {
        showDetail(id){
            this.$inertia.get(`${this.$page.props.appUrl}attendance-views/${id}`);
        },
        loadLazyData() {
            this.loading = true;
            const {id, placement_unit_id, roles} = this.userDetail

            this.lazyParams = {
                ...this.lazyParams,
                month: new Date().getMonth() + 1
            }

            if(roles == 'user') {
                this.lazyParams.id = id
            }

            if(roles == 'client') {
                this.lazyParams.where = JSON.stringify({
                    placement_unit_id: placement_unit_id,
                })

                this.lazyParams.filters = {
                    ...this.filters,
                    roles: {value: "user", matchMode: FilterMatchMode.EQUALS},
                }
            }


            this.datatableService
                .getData(`${this.$page.props.appUrl}api/absensi`, this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        loadSeachableData(){
            axios
            .get(`${this.$page.props.appUrl}api/placement-units`)
            .then((data) => {
                this.placements = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams.first = event.first;
            this.lazyParams.page = event.page;
            this.lazyParams.pageCount = event.pageCount;
            this.lazyParams.rows = event.rows;
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams.sortField = event.sortField;
            this.lazyParams.sortOrder = event.sortOrder;
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        onFilter(event) {
            this.lazyParams.filters['search'] = { field: 'employee.name', value: this.searchFilter };
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS, field: 'id' },
            };
        },
        currentDate(year, month) {
            this.date = new Date(year, month, 0).getDate();
        },
        filterByPlacement(){
            this.lazyParams.filters['global'] = { value: this.placement, matchMode: FilterMatchMode.EQUALS, field: 'employee.placement_id' };
            localStorage.setItem("lazyParams", JSON.stringify(this.lazyParams));

            this.loadLazyData();
        },
    },
};
</script>
<style scoped lang="scss">
@import "../../../../assets/demo/badges.scss";
</style>
